import { useAuth0 } from '@auth0/auth0-react';

export const ADMIN_EMAILS = ['dirk@liquorstore.tech', 'maxime@liquorstore.tech'];

export const useIsAdmin = (): boolean => {
  const { user, isAuthenticated } = useAuth0();

  if (!isAuthenticated || !user?.email) {
    return false;
  }

  return ADMIN_EMAILS.includes(user.email);
};
